var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "marqueeitem-wrapper" }, [
    _c(
      "div",
      { staticClass: "marqueeitem-content" },
      [
        _c(
          "marquee-text",
          {
            key: _vm.refreshNum,
            staticClass: "marqueeitem",
            attrs: { duration: 300, paused: _vm.isStop, repeat: 1 },
          },
          [
            _c(
              "ul",
              { staticClass: "marquee-list" },
              _vm._l(_vm.marquees[_vm.language], function (item) {
                return _c(
                  "li",
                  {
                    on: {
                      click: function ($event) {
                        _vm.isStop = !_vm.isStop
                      },
                    },
                  },
                  [_vm._v(_vm._s(item))]
                )
              }),
              0
            ),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }